const en = {
  confirmSixMonths: 'After this second country change, your next change will be available in 6 months. Accept to continue.',
  confirmYear: 'After this country change, your next change will be available in 1 year. Accept to continue.',
  accept: 'I understand and accept',
  locked: 'You can change your country again on {{date}}.',
  confirmationNeeded: 'Accept the country-change conditions to continue.',
  policyUnavailable: 'Country changes are temporarily unavailable. Try again later.',
  locationDisabled: 'Location services are off. Enable them in your device settings or choose a country manually.',
  locationTimeout: 'Could not get your location in time. Try again or choose a country manually.',
  openSettings: 'Open location settings',
};
const ru = {
  confirmSixMonths: 'Вы меняете страну во второй раз. Следующая смена будет доступна через 6 месяцев. Примите условия, чтобы продолжить.',
  confirmYear: 'После этой смены страны следующая будет доступна через 1 год. Примите условия, чтобы продолжить.',
  accept: 'Понимаю и принимаю',
  locked: 'Снова сменить страну можно будет {{date}}.',
  confirmationNeeded: 'Примите условия смены страны, чтобы продолжить.',
  policyUnavailable: 'Смена страны временно недоступна. Попробуйте позже.',
  locationDisabled: 'Геолокация выключена. Включите её в настройках устройства или выберите страну вручную.',
  locationTimeout: 'Время ожидания местоположения истекло. Повторите попытку или выберите страну вручную.',
  openSettings: 'Открыть настройки геолокации',
};
const es = {
  confirmSixMonths: 'Este es tu segundo cambio de país. Después de este cambio, podrás volver a cambiarlo dentro de 6 meses. Acepta las condiciones para continuar.',
  confirmYear: 'Después de este cambio de país, podrás volver a cambiarlo dentro de 1 año. Acepta las condiciones para continuar.',
  accept: 'Entiendo y acepto',
  locked: 'Podrás volver a cambiar de país el {{date}}.',
  confirmationNeeded: 'Acepta las condiciones del cambio de país para continuar.',
  policyUnavailable: 'No se puede cambiar de país en este momento. Inténtalo más tarde.',
  locationDisabled: 'Los servicios de ubicación están desactivados. Actívalos en los ajustes de tu dispositivo o elige un país manualmente.',
  locationTimeout: 'Se agotó el tiempo para obtener tu ubicación. Inténtalo de nuevo o elige un país manualmente.',
  openSettings: 'Abrir ajustes de ubicación',
};
const fr = {
  confirmSixMonths: 'Vous changez de pays pour la deuxième fois. Après ce changement, vous devrez attendre 6 mois pour le modifier à nouveau. Acceptez les conditions pour continuer.',
  confirmYear: 'Après ce changement de pays, vous devrez attendre 1 an pour le modifier à nouveau. Acceptez les conditions pour continuer.',
  accept: 'Je comprends et j’accepte',
  locked: 'Vous pourrez à nouveau changer de pays le {{date}}.',
  confirmationNeeded: 'Acceptez les conditions du changement de pays pour continuer.',
  policyUnavailable: 'Le changement de pays est temporairement indisponible. Réessayez plus tard.',
  locationDisabled: 'Les services de localisation sont désactivés. Activez-les dans les paramètres de votre appareil ou choisissez un pays manuellement.',
  locationTimeout: 'Le délai de localisation a expiré. Réessayez ou choisissez un pays manuellement.',
  openSettings: 'Ouvrir les paramètres de localisation',
};
const ja = {
  confirmSixMonths: '今回で2回目の国の変更となります。次に変更できるのは6か月後です。続行するには条件に同意してください。',
  confirmYear: '今回、国を変更すると、次に変更できるのは1年後です。続行するには条件に同意してください。',
  accept: '内容を理解し、同意します',
  locked: '{{date}}に再び国を変更できます。',
  confirmationNeeded: '続行するには国の変更条件に同意してください。',
  policyUnavailable: '現在、国を変更できません。しばらくしてからもう一度お試しください。',
  locationDisabled: '位置情報サービスがオフになっています。端末の設定でオンにするか、国を手動で選択してください。',
  locationTimeout: '位置情報の取得がタイムアウトしました。もう一度試すか、国を手動で選択してください。',
  openSettings: '位置情報の設定を開く',
};
const ko = {
  confirmSixMonths: '이번이 두 번째 국가 변경입니다. 변경 후 6개월이 지나야 다시 변경할 수 있습니다. 계속하려면 조건에 동의해 주세요.',
  confirmYear: '이번에 국가를 변경하면 1년이 지나야 다시 변경할 수 있습니다. 계속하려면 조건에 동의해 주세요.',
  accept: '내용을 이해했으며 동의합니다',
  locked: '{{date}}에 국가를 다시 변경할 수 있습니다.',
  confirmationNeeded: '계속하려면 국가 변경 조건에 동의해 주세요.',
  policyUnavailable: '일시적으로 국가를 변경할 수 없습니다. 나중에 다시 시도해 주세요.',
  locationDisabled: '위치 서비스가 꺼져 있습니다. 기기 설정에서 켜거나 국가를 직접 선택해 주세요.',
  locationTimeout: '위치 정보를 가져오는 시간이 초과되었습니다. 다시 시도하거나 국가를 직접 선택해 주세요.',
  openSettings: '위치 설정 열기',
};
const pt = {
  confirmSixMonths: 'Esta é a sua segunda alteração de país. Após esta alteração, você poderá mudar novamente daqui a 6 meses. Aceite as condições para continuar.',
  confirmYear: 'Após esta alteração de país, você poderá mudar novamente daqui a 1 ano. Aceite as condições para continuar.',
  accept: 'Entendo e aceito',
  locked: 'Você poderá alterar seu país novamente em {{date}}.',
  confirmationNeeded: 'Aceite as condições de alteração de país para continuar.',
  policyUnavailable: 'A alteração de país está temporariamente indisponível. Tente novamente mais tarde.',
  locationDisabled: 'Os serviços de localização estão desativados. Ative-os nas configurações do dispositivo ou escolha um país manualmente.',
  locationTimeout: 'O tempo para obter sua localização se esgotou. Tente novamente ou escolha um país manualmente.',
  openSettings: 'Abrir configurações de localização',
};
const tr = {
  confirmSixMonths: 'Ülkenizi ikinci kez değiştiriyorsunuz. Bu değişiklikten sonra yeniden değişiklik yapmak için 6 ay beklemeniz gerekir. Devam etmek için koşulları kabul edin.',
  confirmYear: 'Bu ülke değişikliğinden sonra yeniden değişiklik yapmak için 1 yıl beklemeniz gerekir. Devam etmek için koşulları kabul edin.',
  accept: 'Anladım ve kabul ediyorum',
  locked: 'Ülkenizi {{date}} tarihinde yeniden değiştirebilirsiniz.',
  confirmationNeeded: 'Devam etmek için ülke değişikliği koşullarını kabul edin.',
  policyUnavailable: 'Ülke değişikliği geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.',
  locationDisabled: 'Konum hizmetleri kapalı. Cihazınızın ayarlarından açın veya bir ülkeyi elle seçin.',
  locationTimeout: 'Konumunuz zamanında alınamadı. Tekrar deneyin veya bir ülkeyi elle seçin.',
  openSettings: 'Konum ayarlarını aç',
};
const zh = {
  confirmSixMonths: '本次为第二次更改国家。更改后需等待 6 个月才能再次更改。请接受条件以继续。',
  confirmYear: '本次更改国家后，需等待 1 年才能再次更改。请接受条件以继续。',
  accept: '我理解并接受', locked: '您可以在 {{date}} 再次更改国家。',
  confirmationNeeded: '请先接受更改国家的条件。', policyUnavailable: '暂时无法更改国家，请稍后重试。',
  locationDisabled: '定位服务已关闭。请在设备设置中开启，或手动选择国家。',
  locationTimeout: '定位超时。请重试或手动选择国家。', openSettings: '打开定位设置',
};
const de = {
  confirmSixMonths: 'Du änderst dein Land zum zweiten Mal. Danach kannst du es erst in 6 Monaten wieder ändern. Akzeptiere die Bedingungen, um fortzufahren.',
  confirmYear: 'Nach dieser Länderänderung kannst du dein Land erst in 1 Jahr wieder ändern. Akzeptiere die Bedingungen, um fortzufahren.',
  accept: 'Ich verstehe und akzeptiere',
  locked: 'Du kannst dein Land am {{date}} wieder ändern.',
  confirmationNeeded: 'Akzeptiere die Bedingungen für die Länderänderung, um fortzufahren.',
  policyUnavailable: 'Das Land kann vorübergehend nicht geändert werden. Versuche es später erneut.',
  locationDisabled: 'Die Standortdienste sind deaktiviert. Aktiviere sie in den Geräteeinstellungen oder wähle ein Land manuell aus.',
  locationTimeout: 'Die Standortabfrage hat zu lange gedauert. Versuche es erneut oder wähle ein Land manuell aus.',
  openSettings: 'Standorteinstellungen öffnen',
};
const it = {
  confirmSixMonths: 'Questo è il tuo secondo cambio di paese. Dopo questo cambio, potrai modificarlo di nuovo tra 6 mesi. Accetta le condizioni per continuare.',
  confirmYear: 'Dopo questo cambio di paese, potrai modificarlo di nuovo tra 1 anno. Accetta le condizioni per continuare.',
  accept: 'Ho capito e accetto',
  locked: 'Potrai cambiare di nuovo paese il {{date}}.',
  confirmationNeeded: 'Accetta le condizioni per il cambio di paese per continuare.',
  policyUnavailable: 'Al momento non è possibile cambiare paese. Riprova più tardi.',
  locationDisabled: 'I servizi di localizzazione sono disattivati. Attivali nelle impostazioni del dispositivo oppure scegli un paese manualmente.',
  locationTimeout: 'Il tempo per rilevare la tua posizione è scaduto. Riprova oppure scegli un paese manualmente.',
  openSettings: 'Apri le impostazioni di localizzazione',
};
const hi = {
  confirmSixMonths: 'आप दूसरी बार देश बदल रहे हैं। इस बदलाव के बाद आप 6 महीने तक देश नहीं बदल पाएँगे। जारी रखने के लिए शर्तें स्वीकार करें।',
  confirmYear: 'इस बदलाव के बाद आप 1 साल तक देश नहीं बदल पाएँगे। जारी रखने के लिए शर्तें स्वीकार करें।',
  accept: 'मैं समझता/समझती हूँ और स्वीकार करता/करती हूँ',
  locked: 'आप {{date}} को फिर से देश बदल सकेंगे।',
  confirmationNeeded: 'जारी रखने के लिए देश बदलने की शर्तें स्वीकार करें।',
  policyUnavailable: 'अभी देश बदलना संभव नहीं है। बाद में फिर से कोशिश करें।',
  locationDisabled: 'लोकेशन सेवाएँ बंद हैं। इन्हें डिवाइस की सेटिंग में चालू करें या देश खुद चुनें।',
  locationTimeout: 'लोकेशन का पता लगाने की समय-सीमा समाप्त हो गई। फिर से कोशिश करें या देश खुद चुनें।',
  openSettings: 'लोकेशन सेटिंग खोलें',
};
const translations = { en, ru, es, fr, ja, ko, pt, tr, zh, de, it, hi };
export default translations;
